import PLReport from './PLReport'

export default (store) => ({
  path: '/reports',
  childRoutes: [
    PLReport(store)
  ],
  indexRoute: {
    onEnter: (nextState, replace) => replace('/reports/pl')
  }
})
